import MakePaymentModule from './MakePaymentModule';

export default MakePaymentModule;